import {IntermediatePart} from "../../intermediatePart";
import {PLACEMENTS} from "../../../../kvComponent/core/constants";

export default class Sink extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'sink';
    this.partName = 'Sink';
    this.translateId = "visualizer.kitchen.countertop.sink";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Island)) {
      return false
    }
    return super.load_(dbFeature, new Sink());
  }

  disabledClick() {
    const relatedFaucet = this.getParent().faucet;
    if (relatedFaucet) {
      relatedFaucet.disabled = this.disabled;
    }
  }
}
